import React from "react";

const ConfigStateContext = React.createContext();

export const ConfigProvider = ({ children, config = {} }) => {
  return <ConfigStateContext.Provider value={config}>{children}</ConfigStateContext.Provider>;
};

const useConfig = () => {
  const context = React.useContext(ConfigStateContext);

  if (context === undefined) {
    console.error("useConfig used outside ConfigProvider. No config returned");
    return {};
  }

  return context;
};

export const withConfigContext = Component => {
  return props => {
    return (
      <ConfigStateContext.Consumer>
        {(context) => {
          return <Component {...props} {...context} />;
        }}
      </ConfigStateContext.Consumer>
    );
  };
};

export default useConfig;
